import {useEffect} from 'react';

import {useHttpClient} from 'hooks';

export default function useSupportedWebeosServerVersions() {
  const {data, loading, cancel, error} = useHttpClient({
    url: `/api/webeos/supported-server-versions`,
    method: 'GET',
  });

  useEffect(() => {
    return () => {
      cancel('Request to /api/webeos/supported-server-versions has been cancelled');
    };
  }, [cancel]);

  return {
    isLoading: loading,
    supportedWebEOSVersions: data && !loading ? data.supportedVersions : [],
    error,
  };
}
